const work = [
    {
        id: 'owsec',
        primary: 'Research & Development Intern',
        secondary: 'Research & Development Department, Onward Security, Taiwan',
        content: [
            {
                id: 'frontend',
                title: 'Frontend Development',
                description: 'Implement the frontend UI of a security compliance assistive system with React JS'
            },
            {
                id: 'securityStandards',
                title: 'Security',
                description: 'Research on cybersecurity standards including IEC62443 and NIST',
            },
            {
                id: 'anomalyDetection',
                title: 'Machine Learning',
                description: 'Survey machine learning approaches to anomaly detection using system logs',
            }
        ]
    },
    {
        id: 'iis',
        primary: 'Research Intern',
        secondary: 'Institute of Information Science(IIS), Academia Sinica, Taiwan',
        content: [
            {
                id: 'routing',
                title: 'Project',
                description: 'Developed a routing system of “cleanest air” using Java and Python Django',
            },
            {
                id: 'gis',
                title: 'Knowledge and Tools',
                description: 'Researched on open source GIS programming software and graph algorithms',
            }
        ]
    },
]

export { work }